// @flow
import type { IConstraintModel } from "../../types";

/**
 */
class MandatoryConstraint implements IConstraintModel {
  /**
   */
  get id(): string {
    return "Constraint.Mandatory";
  }

  /**
   */
  hasValidation(): boolean {
    return true;
  }

  /**
   */
  get defaultMessage(): string {
    return "Field is mandatory";
  }

  /**
   */
  get parameters(): { ... } {
    return {};
  }

  /**
   */
  validate(value: string): boolean {
    if (value == null) {
      return false;
    }

    if (typeof value != "string") {
      throw new TypeError(
        `isNotEmptyString: Not comparing to string: ${typeof value}`,
      );
    }

    return value !== "";
  }

  /**
   */
  get isMandatoryConstraint(): boolean {
    return true;
  }
}

export default MandatoryConstraint;
